import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { LoadingScreenComponent } from './pages/loading-screen/loading-screen.component';
import { LoggedOutComponent } from './pages/logged-out/logged-out.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';


/**
 * Routes
 */
const routes: Routes = [
  {
    path: '',
    component: LoadingScreenComponent,
  },
  { path: 'signin', loadChildren: () => import('./pages/signin/signin.module').then(m => m.SigninModule) },
  { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) },
  { path: 'exit', component: LoggedOutComponent },
  { path: '404', component: NotFoundComponent },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
})],
  exports: [RouterModule]
})
  /**
   * App routing module
   */
export class AppRoutingModule {
}

/**
 * Checks if the application is running inside an iframe.
 * @returns True if running inside an iframe, false otherwise.
 */
export function isInIframe() {
  return window !== window.parent && !window.opener;
}
